import TableSectionEditor from "./TableSectionEditor";
import QuizSectionEditor from "./QuizSectionEditor";
import HighlightSectionEditor from "./HighlightSectionEditor";
import MediaPromptSectionEditor from "./MediaPromptSectionEditor";
import MathWorkSectionEditor from "./MathWorkSectionEditor";

const SECTION_EDITOR_REGISTRY = {
  table: TableSectionEditor,
  quiz: QuizSectionEditor,
  highlight: HighlightSectionEditor,
  media: MediaPromptSectionEditor,
  "math-work": MathWorkSectionEditor,
};

export const getSectionEditorComponent = (type) =>
  (type && SECTION_EDITOR_REGISTRY[type]) || null;

export default SECTION_EDITOR_REGISTRY;
